import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';

/**
 * Root ('/') route: sends the user to their role's default page, configured in
 * Role Permissions. Falls back to the dashboard.
 */
export const defaultPageGuard: CanActivateFn = () => {
   const router = inject(Router);
   return inject(PermissionService)
      .resolveLandingPage()
      .pipe(map((path) => router.parseUrl(path)));
};
